import React, { memo, useEffect } from 'react';
import { FormStep, FormStepInternalState, StepsState } from '../../../model/global';
import MainEnquiry from '../../FormSteps/MainEnquiry';
import ProductCategory from '../../FormSteps/ProductCategory';
import CustomerAddress from '../../FormSteps/CustomerAddress';
import AdditionalInformation from '../../FormSteps/AdditionalInformation';
import FileAttachments from '../../FormSteps/FileAttachments';
import FormSummary from '../../FormSteps/FormSummary';
import { useValidateStepQuery } from '../../../store/modules/services/validateStepApi/hooks';
import { stepsActions } from '../../../store/modules/steps/reducer';
import { useDispatch, useSelector } from 'react-redux';
import { validateStep } from '../../../store/modules/steps/thunks';
import { formSummarySelector } from '../../../store/modules/steps/selectors';

interface Props {
	step: FormStep;
}
const FormStepContent: React.FC<Props> = ({ step }) => {
	const dispatch = useDispatch()
	const summary = useSelector(formSummarySelector) as StepsState['formSummary']

	const handleStepControlsChange = (stepFields: FormStepInternalState['fields'], stepTemplate: FormStep['stepTemplate']): void => {
		// @todo - handle file fields?
	}


	const renderStep = (step: FormStep): JSX.Element | undefined => {
		switch (step.stepTemplate) {
			case 'MAIN_ENQUIRY':
				return <MainEnquiry data={step} onStepControlsChange={e => handleStepControlsChange(e, step.stepTemplate)}></MainEnquiry>
			case 'PRODUCT_CATEGORY':
				return <ProductCategory data={step} onStepControlsChange={e => handleStepControlsChange(e, step.stepTemplate)}></ProductCategory>
			case 'CUSTOMER_ADDRESS':
				return <CustomerAddress data={step} onStepControlsChange={e => handleStepControlsChange(e, step.stepTemplate)}></CustomerAddress>
			case 'ADDITIONAL_INFORMATION':
				return <AdditionalInformation data={step} onStepControlsChange={e => handleStepControlsChange(e, step.stepTemplate)}></AdditionalInformation>
			case 'FILE_ATTACHMENTS':
				return <FileAttachments data={step} onStepControlsChange={e => handleStepControlsChange(e, step.stepTemplate)}></FileAttachments>
			case 'FORM_SUMMARY':
				return <FormSummary data={step} onStepControlsChange={e => handleStepControlsChange(e, step.stepTemplate)}></FormSummary>
			default: return undefined;
		}
	}
	return (
		<>
			{ renderStep(step) || null }
		</>
	);
};

export default memo(FormStepContent);
